function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { PureComponent, cloneElement } from 'react';
import Events from '../utils/events';
import DragProps, { DragEvent, DragState } from './PropsType';
export { DragProps, DragEvent, DragState };

var Drag =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Drag, _PureComponent);

  function Drag() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Drag);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Drag)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.currentX = void 0;
    _this.currentY = void 0;
    _this.dragState = Object.create(null);

    _this.onTouchStart = function (event) {
      _this.dragState.startTime = new Date();

      if (!event.touches) {
        _this.dragState.startX = event.clientX;
        _this.dragState.startY = event.clientY;
        Events.on(document.body, 'mousemove', _this.onTouchMove);
        Events.on(document.body, 'mouseup', _this.onTouchEnd);
      } else {
        var touch = event.touches[0];
        _this.dragState.startX = touch.pageX;
        _this.dragState.startY = touch.pageY;
      }

      var state = _objectSpread({}, _this.dragState);

      var onDragStart = _this.props.onDragStart;

      if (typeof onDragStart === 'function') {
        onDragStart(event, state);
      }
    };

    _this.onTouchMove = function (event) {
      if (!_this.isDragStart) return false;

      if (!event.touches) {
        _this.currentX = event.clientX;
        _this.currentY = event.clientY;
      } else {
        var touch = event.touches[0];
        _this.currentX = touch.pageX;
        _this.currentY = touch.pageY;
      }

      var offsetX = _this.currentX - _this.dragState.startX;
      var offsetY = _this.currentY - _this.dragState.startY;

      var state = _objectSpread({}, _this.dragState, {
        offsetX: offsetX,
        offsetY: offsetY // currentX: this.currentX,
        // currentY: this.currentY,

      });

      var onDragMove = _this.props.onDragMove;

      if (typeof onDragMove === 'function' && !onDragMove(event, state)) {
        return;
      }

      _this.dragState = state;
    };

    _this.onTouchEnd = function (event) {
      if (!_this.isDragStart) return false;

      if (event && !event.touches) {
        Events.off(document.body, 'mousemove', _this.onTouchMove);
        Events.off(document.body, 'mouseup', _this.onTouchEnd);
      }

      var onDragEnd = _this.props.onDragEnd;

      if (typeof onDragEnd === 'function') {
        onDragEnd(event, _this.dragState);
      }

      _this.dragState = Object.create(null);
    };

    return _this;
  }

  _createClass(Drag, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return cloneElement(children, {
        onTouchStart: this.onTouchStart,
        onTouchMove: this.onTouchMove,
        onTouchEnd: this.onTouchEnd,
        onMouseDown: this.onTouchStart,
        onMouseMove: this.onTouchMove,
        onMouseUp: this.onTouchEnd
      });
    }
  }, {
    key: "isDragStart",
    get: function get() {
      return this.dragState.startX !== undefined && this.dragState.startY !== undefined;
    }
  }]);

  return Drag;
}(PureComponent);

export { Drag as default };